import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as api from "./categoryApi";

export const fetchCategories = createAsyncThunk("category/fetchCategories", async (_, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getCategories({ flat: true }, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch categories");
  }
});

export const createCategory = createAsyncThunk("category/createCategory", async (data, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.createCategory(data, token);
    toast.success("Category created successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to create category";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const updateCategory = createAsyncThunk("category/updateCategory", async ({ id, data }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.updateCategory(id, data, token);
    toast.success("Category updated successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to update category";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const deleteCategory = createAsyncThunk("category/deleteCategory", async (id, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    await api.deleteCategory(id, token);
    toast.success("Category deleted successfully");
    return id;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to delete category";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

const categorySlice = createSlice({
  name: "category",
  initialState: { categories: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload?.categories || action.payload || [];
      })
      .addCase(fetchCategories.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createCategory.fulfilled, (state, action) => {
        const cat = action.payload?.category || action.payload;
        if (cat?._id) state.categories.push(cat);
      })
      .addCase(createCategory.rejected, (state, action) => { state.error = action.payload; })

      .addCase(updateCategory.fulfilled, (state, action) => {
        const cat = action.payload?.category || action.payload;
        if (cat?._id) {
          const idx = state.categories.findIndex((c) => c._id === cat._id);
          if (idx !== -1) state.categories[idx] = cat;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => { state.error = action.payload; })

      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter((c) => c._id !== action.payload);
      })
      .addCase(deleteCategory.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default categorySlice.reducer;
